import { HeroRegistryEntry } from '../types';
import HeroA from './HeroA/HeroA';
import { manifest as heroAManifest } from './HeroA/manifest';
import HeroReserve from './HeroReserve/HeroReserve';
import { manifest as heroReserveManifest } from './HeroReserve/manifest';
import HeroEcommerce from './HeroEcommerce/HeroEcommerce';
import { manifest as heroEcommerceManifest } from './HeroEcommerce/manifest';
import HeroEcommerceSlider from './HeroEcommerceSlider/HeroEcommerceSlider';
import { manifest as heroEcommerceSliderManifest } from './HeroEcommerceSlider/manifest';
import {
  HEADER_TEMPLATE_ECOMMERCE,
  HEADER_TEMPLATE_ECOMMERCE_SLIDER,
  HEADER_TEMPLATE_HERO_A,
  HEADER_TEMPLATE_RESERVE,
  normalizeHeaderTemplateCode,
} from '../../templateCodes';

export const heroRegistry: HeroRegistryEntry[] = [
  {
    code: HEADER_TEMPLATE_HERO_A,
    Component: HeroA,
    manifest: heroAManifest,
    headerVariant: 'hero_a',
  },
  {
    code: HEADER_TEMPLATE_RESERVE,
    Component: HeroReserve,
    manifest: heroReserveManifest,
    headerVariant: 'reserve',
  },
  {
    code: HEADER_TEMPLATE_ECOMMERCE,
    Component: HeroEcommerce,
    manifest: heroEcommerceManifest,
    headerVariant: 'ecommerce',
  },
  {
    code: HEADER_TEMPLATE_ECOMMERCE_SLIDER,
    Component: HeroEcommerceSlider,
    manifest: heroEcommerceSliderManifest,
    headerVariant: 'ecommerce_slider',
  },
];

export function getHeroTemplate(code?: string): HeroRegistryEntry {
  const normalized = normalizeHeaderTemplateCode(code);
  return (
    heroRegistry.find((entry) => entry.code === normalized) ??
    heroRegistry.find((entry) => entry.code === HEADER_TEMPLATE_HERO_A)
  );
}
